import { useQuery } from "@/api/swr/useQuery";
import { sdgTargetSchema } from "@/schema/console/sdg-targets/SdgTarget";
import { z } from "zod";

const sdgTargetsSchema = z.array(sdgTargetSchema);

type Config = Parameters<typeof useQuery<typeof sdgTargetsSchema>>[2];

export function useGetSdgTargets(config: Config) {
  return useQuery(sdgTargetsSchema, "/console/sdg_targets", config);
}
